import { useEffect, useState } from "react";
import { withErrorBoundary } from "@sentry/nextjs";
import { useRouter } from "next/navigation";
import { createPortal } from "react-dom";
import { openDetailPageCalendar } from "components/date-picker/date-range-input/CalendarPopOver";
import { selectBookingStore } from "stores/booking/bookingSlice";
import { useAppSelector } from "stores/hooks";
import { useMediaQuery } from "utils/hooks/useMediaQuery";
const PrequoteErrorModal = (props: {
  isOpen: boolean;
  onClose: () => void;
  placeURL?: string;
}) => {
  const {
    isOpen,
    onClose,
    placeURL
  } = props;
  const bookingStore = useAppSelector(selectBookingStore);
  const [isMounted, setIsMounted] = useState(false);
  const [isLargerThan992] = useMediaQuery("(min-width: 992px)");
  const router = useRouter();
  useEffect(() => {
    setIsMounted(true);
    return () => {
      setIsMounted(false);
    };
  }, []);
  if (!isOpen || !isMounted) {
    return null;
  }
  return createPortal(<div className='fixed inset-0 z-[3000] h-[100dvh] h-screen w-full bg-[#00000042]' onClick={event => {
    if (event.target === event.currentTarget) {
      onClose();
    }
  }} role='button' onKeyDown={() => {}} tabIndex={-1}>
      <div className='pointer-events-none flex h-full w-full items-center justify-center p-4'>
        {bookingStore.status === 417 && bookingStore.error ? <div className='pointer-events-auto mx-auto max-w-[32rem] rounded-[1.25rem] bg-white px-4 py-7 text-center shadow-lg sm:px-12'>
            <p data-nosnippet className='text-center font-medium text-secondary700 md:font-semibold'>
              {bookingStore.error}
            </p>
            <div className='mt-5 flex justify-center gap-2 xsm:gap-3'>
              <button type='button' onClick={() => {
            openDetailPageCalendar(isLargerThan992 ? "calendarTrigger" : "MobileCalendarTrigger");
            onClose();
          }} className='btn btn-primary px-3 text-sm font-semibold sm:px-5 md:text-base md:leading-7'>
                Ok
              </button>
            </div>
          </div> : <div className='pointer-events-auto mx-auto max-w-[32rem] rounded-[1.25rem] bg-white px-4 py-7 text-center shadow-lg sm:px-12'>
            <p data-nosnippet className='mb-2 text-center text-lg font-semibold text-secondary700 md:text-xl md:font-bold'>
              Those dates just got booked
            </p>
            <p data-nosnippet className='text-center font-medium text-secondary700 md:font-semibold'>
              There are plenty of other great places waiting for you. Want to
              explore more or try new dates?
            </p>
            <div className='mt-5 flex justify-center gap-2 xsm:gap-3'>
              <button type='button' onClick={() => {
            if (placeURL) {
              router.push(placeURL);
            } else {
              const element = document.getElementById("backToSearchLink");
              if (element) {
                element.click();
              }
            }
            onClose();
          }} className='btn btn-primary px-3 text-sm font-semibold sm:px-5 md:text-base md:leading-7'>
                See other stays
              </button>
              <button type='button' onClick={() => {
            openDetailPageCalendar(isLargerThan992 ? "calendarTrigger" : "MobileCalendarTrigger");
            onClose();
          }} className='btn btn-white border-[#8D8D8D] px-3 text-sm font-semibold leading-6 text-[#000] shadow-[0px_2px_8px_0px_#22222214] hover:border-secondary1000 hover:text-secondary1000 sm:px-5'>
                Adjust your dates
              </button>
            </div>
          </div>}
      </div>
    </div>, document.body);
};
export default withErrorBoundary(PrequoteErrorModal, {
  beforeCapture: scope => {
    scope.setTag("ws_location", "PrequoteErrorModal");
  }
});